var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"max-height":"500","data":_vm.customers},on:{"row-click":_vm.showDetail}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"show-overflow-tooltip":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }